import React from 'react';
import { Switch as AntdSwitch } from 'antd';

/**
 * a toggle component
 *
 * {@link https://ant.design/components/switch#api}
 *
 * @module Switch
 * @param {Object} props - the switch props
 * @param {Function} [props.onChange] - the function to call when the switch is toggled.
 * @param {string} [props.size] - the size of the switch
 * @returns {React.ReactElement} the rendered switch component
**/
const Switch = ( props ) => {

    const onChange = ( value ) => {
        if ( typeof props.onChange === 'function' ) {
            props.onChange( value );
        }
    };

    const getSizeClassNames = () => {
        if ( props.size === 'large' ) {
            return ( 'origami-switch origami-switch-large' );
        }
        else {
            return ( 'origami-switch' );
        }
    };

    return (
        <AntdSwitch
            className={ getSizeClassNames() }
            onChange={ onChange }
            size={ props.size === 'small' ? 'small' : 'default' }
            disabled={ props.disabled }
            defaultChecked={ props.defaultChecked }
            loading={ props.loading }
            checked={ props.checked }
        ></AntdSwitch>
    );
};

export { Switch };
